import {PAGE_NUMBER, TOTAL_RESULTS, TOTAL_PAGES, PER_PAGE} from '../actions';

export default (state = {pageNum: 1, perPage: 12, totalResults: 0, totalPages: 0}, action) => {
	switch (action.type) {
		case PAGE_NUMBER:
			return {
				pageNum: action.payload,
				perPage: state.perPage,
				totalResults: state.totalResults,
				totalPages: state.totalPages
			};
		case PER_PAGE:
			return {
				pageNum: state.pageNum,
				perPage: action.payload,
				totalResults: state.totalResults,
				totalPages: state.totalPages
			};
		case TOTAL_RESULTS:
			return {
				pageNum: state.pageNum,
				perPage: state.perPage,
				totalResults: action.payload,
				totalPages: state.totalPages
			};
		case TOTAL_PAGES:
			return {
				pageNum: state.pageNum,
				perPage: state.perPage,
				totalResults: state.totalResults,
				totalPages: action.payload
			};
	}

	return state;
}